// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyTwoToneSvg from "@fishx/icons-svg/es/asn/CopyTwoTone";
import FishxIcon from '../components/FishxIcon';

var CopyTwoTone = function CopyTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyTwoToneSvg
  }));
};

CopyTwoTone.displayName = 'CopyTwoTone';
export default React.forwardRef(CopyTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CopyTwoTone.js
// module id = 2325
// module chunks = 0